/*!
=========================================================
* 駐車場マスタ
=========================================================
*/
import React from "react";

import {
  CardImg, Col,
  FormGroup,
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import Common from '../../common/Common';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import InputText from '../FormParts/InputText'
import Definition from '../../common/Definition';
import InputSelect from '../FormParts/InputSelect';
import OptionConvert from '../../common/OptionConvert';
import InputCheckBox from "../FormParts/InputCheckBox";

import GoogleDrive from '../../common/GoogleDrive';

import {
  cst_ab_select
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';

const domain = "";

class List extends ListBase {
  default_column = [
    { Header: '駐車場ID', accessor: 'PARKING__parking_natural_id', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '駐車場名', accessor: '___JOIN_parking', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '所在地', accessor: '___JOIN_parking_addr', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '駐車場写真URL：サムネイル', accessor: 'PARKING__parking_picture_url_thumbnail', headerClassName: "text-center", className: "text-left text-top" },
    { Header: 'ワゴン車', accessor: 'PARKING__capacity_flag_car', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '軽トラック', accessor: 'PARKING__capacity_flag_light_truck', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '2tトラック', accessor: 'PARKING__capacity_flag_truck', headerClassName: "text-center", className: "text-left text-top" },
    { Header: '最終更新者', accessor: 'PARKING__lastupdate_user_id', headerClassName: "text-center", className: "text-left text-top" }
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '駐車場マスタ',
      //search_url: '/api/parking',
      search_url: '/api/parking/unlimit',
      column: this.default_column,
      valid: true,
      badge:false,
      searchData:{
        values:{
          show_delete_data : '0'
        },
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      auto_scroll:true,
    });

    this.validateCallback = this.validateCallback.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.optionsById(res.Data)
      this.setState({landmark_user:user_list});
    })
  }

  dataMap(data) {
    return data.map((prop, key) => {
      return {
        id: key,
        PARKING__parking_natural_id:(<Link target="_blank" to={"/parking/detail/" + prop.ulid}>{prop.parking_natural_id}</Link>),
        ___JOIN_parking:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking', prop)}} />,
        ___JOIN_parking_addr:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_addr', prop)}} />,
        PARKING__parking_picture_url_thumbnail:prop.parking_picture_url_thumbnail ? (
            <CardImg top src={GoogleDrive.file_url(prop.parking_picture_url_thumbnail)} alt="" style={{ "maxWidth": "100px" }} />
          ) : (
              "写真なし"
            ),
        PARKING__capacity_flag_car:Common.getValueFormDictArray(cst_ab_select, prop.capacity_flag_car),
        PARKING__capacity_flag_light_truck:Common.getValueFormDictArray(cst_ab_select, prop.capacity_flag_light_truck),
        PARKING__capacity_flag_truck:Common.getValueFormDictArray(cst_ab_select, prop.capacity_flag_truck),
        PARKING__lastupdate_user_id:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_update', prop)}} />
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  add_field_cols() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <Col md="6">
          <ButtonWithTooltipWithRole
              button_id="BTN_M3_01_04380"
              onclick={() => { this.props.history.push('/parking/add') }}
              class="float-right btn-search btn-facebook"
              id="tmp"
              icon="fas fa-plus"
              label="追加"
              message="データを追加"
          />
        </Col>
      </>
    );
  }

  search() {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
          this.setState({
            paging: {
              "index": parseInt(searchParmas["pager_index"]),
              "limit": parseInt(searchParmas["pager_limit"])
            },  
            data: this.dataMap(res.Data)
          });
    })
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }
  
  search_field_cols() {
    return (
      <>
        <Col md="3">
          <FormGroup>
          <InputText
            label='駐車場名'
            name='PARKING__parking_name'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
          <InputText
            label='仕入先TEL'
            name='SUPPLIER__supplier_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='市区町村'
              name='PARKING__parking_city'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='番地（町名以降）'
              name='PARKING__parking_address'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label='最終更新者'
              name='PARKING__lastupdate_user_id'
              labelOn={true}
              options={this.state.landmark_user}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              isSearchable={true}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <InputCheckBox
            label='削除データも表示'
            name='NODB__show_delete_data'
            labelOn={false}
            checkedValue={'1'}
            uncheckedValue={'0'}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        {/* <Col md="6">
          <FormGroup>
            <InputCheckBox
              label='駐車場名・電話番号・所在地を含まないデータのみを表示する'
              name='TEMP__parking_search_check'
              labelOn={false}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col> */}
      </>
    );
  }
}

export default List;
